export const SAVE_TEXT = 'save_text';
export const FETCH_IMAGE = 'fetch_image';
export const CHANGE_IMAGE = 'change_image';
export const SAVE_POST = 'save_post';
export const DELETE_POST = 'delete_post';
